module.exports = __webpack_public_path__ + "static/media/zone3-interior.d3830520.png";